import { render } from "./OnBehalfOfBase.vue?vue&type=template&id=5e506ea9&ts=true"
import script from "./OnBehalfOfBase.vue?vue&type=script&lang=ts"
export * from "./OnBehalfOfBase.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__